import React from 'react';
import { Age, Code } from './LivePage';
import PagedWorkloadPage from './PagedWorkloadPage';

/**
 * Role Bindings — who a Role is granted to.
 *
 * The sidebar linked to /role-bindings with no route and no component, so it hit the
 * path="*" catch-all and silently landed on the Dashboard. This is that page.
 */
export default function RoleBindings() {
  return (
    <PagedWorkloadPage
      title="Role Bindings" kind="RoleBinding" resource="rolebindings"
      label="role bindings" detail={false}
      cols={['Name', 'Namespace', 'Role', 'Subjects', 'Age']}
      renderRow={b => [
        <td key="n"><Code>{b.name}</Code></td>,
        <td key="ns" style={{ color: 'var(--ink-2)', fontSize: 13 }}>{b.namespace}</td>,
        <td key="r" style={{ fontSize: 12 }}>{b.role || '—'}</td>,
        <td key="s" style={{ fontSize: 12, color: 'var(--muted)' }}>
          {(b.subjects || []).join(', ') || '—'}
          {b.subject_count > (b.subjects || []).length && (
            <span> +{b.subject_count - (b.subjects || []).length} more</span>
          )}
        </td>,
        <td key="a"><Age ts={b.created_at} /></td>,
      ]}
    />
  );
}
